import "../Styles/Pages/Contact.css";
import { useState } from "react";

const Contact = () => {
  const [contactUsInfo, setContactUsInfo] = useState({
    firstName: "",
    lastName: "",
    subject: "",
    message: "",
  });

  function handleContactUsChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    setContactUsInfo((prevContactUsInfo) => {
      return {
        ...prevContactUsInfo,
        [name]: value,
      };
    });
    console.log(contactUsInfo);
  }

  const handleContinue = (e) => {
    e.preventDefault();
    const { firstName, lastName, subject, message } = contactUsInfo;

    const recipientEmail = 'madrasahzulaykha@gmail.com';
    const body = `${firstName} ${lastName}\n\n${message}`;
    const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
  };

  return (
    <div className="contact">
      <h1>Contact Us</h1>
      <form onSubmit={handleContinue}>
        <input
          type="text"
          name="firstName"
          value={contactUsInfo.firstName}
          onChange={handleContactUsChange}
          placeholder="First Name"
        />
        <input
          type="text"
          name="lastName"
          value={contactUsInfo.lastName}
          onChange={handleContactUsChange}
          placeholder="Last Name"
        />
        <input
          type="text"
          name="subject"
          value={contactUsInfo.subject}
          onChange={handleContactUsChange}
          placeholder="Subject"
        />
        <label>
          Message
          <textarea
            name="message"
            required
            placeholder="Write your message here"
            value={contactUsInfo.message}
            onChange={handleContactUsChange}
          ></textarea>
        </label>
        <input type="submit" name="submit" value="Continue" />
      </form>
    </div>
  );
};

export default Contact;
